import { Vehicle } from "../../../../types";
import VehicleCard from "../VehicleCard/VehicleCard";
import "./styles.css";
type CarSectionProps = {
  title: string;
  icon: React.ReactNode;
  vehicles: Vehicle[];
}
const CarSection = (props: CarSectionProps) => {
  const { title, vehicles, icon } = props;
  return (
    <div className="max-w-screen-xl w-full mx-auto">
      <div className="car-section-title">
        <i>{icon}</i>
        <span>{title}</span>
      </div>
      <div className="car-section-cards">
        {vehicles.map((vehicle: Vehicle) => (
          <div key={vehicle.id} className="col-span-1">
            <VehicleCard key={vehicle.id} vehicle={vehicle} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarSection;